// * LIVE
// * Projects completed and published - the content here may not reflect the versions
// * changes are often made after production versions are made in stash repo

// ! 2018
// import content from '@/content/projects/2018/0225-oscars-poll'
// import content from '@/content/projects/2018/0225-oscars-quiz'
// import content from '@/content/projects/2018/0502-royal-wedding-tilequiz'
// import content from '@/content/projects/2018/0502-royalwedding-bingo'
// import content from '@/content/projects/2018/0503-calorie-calculator'
// import content from '@/content/projects/2018/0427-nca_salary_suburbs'
// import content from '@/content/projects/2018/0525-richlist-top5s'
// import content from '@/content/projects/2018/0601-nca-spelling-quiz'
// import content from '@/content/projects/2018/0617-nnd-portugal-timeline'
// import content from '@/content/projects/2018/0708-serialkiller-map'
// import content from '@/content/projects/2018/0713-head2head-trump-putin'
// import content from '@/content/projects/2018/0721-super-balance'
// import content from '@/content/projects/2018/0817-thurston-links'
// import content from '@/content/projects/2018/0824-adv-showbags-promolink' // countdown
// import content from '@/content/projects/2018/0824-adv-showbags'
// import content from '@/content/projects/2018/demo-d3-circle-cluster'
// import content from '@/content/projects/2018/0926-dallym-team'
// import content from '@/content/projects/2018/0926-dallym-games'
// import content from '@/content/projects/2018/demo-best-books'
// import content from '@/content/projects/2018/demo-player-ratings'
// import content from '@/content/projects/2018/1001-buzz-top50-moments'
// import content from '@/content/projects/2018/0907-sa-politicians-own'
// import content from '@/content/projects/2018/1018-top-aleague-men'
// import content from '@/content/projects/2018/1009-future-seq-links'
// import content from '@/content/projects/2018/demo-bookclub-fluid-image-grid'
// import content from '@/content/projects/2018/1102-let-her-speak-stories'
// import content from '@/content/projects/2018/1119-CM-qld-top-athletes'

// ! 2019
// import content from '@/content/projects/2019/0204-sa-top-100-people'
// import content from '@/content/projects/2019/sa-election-policy-dashboard'
// import content from '@/content/projects/2019/0305-dt-supercoach-20-players-to-watch'
// import content from '@/content/projects/2019/NED-0154-election-sa-policy-picker-quiz'
// import content from '@/content/projects/2019/NED-0285-nsw-suburb-crime-stats-phase1'
// import content from '@/content/projects/2019/NED-0380-operation-wait-times'
import content from '@/content/projects/2019/NED-0534-got-show-matcher'


// * DEV + DEMOS
// * Projects under active development, didn't make it to live builds, demos, experiments...
// import content from '@/content/projects/demo/demo'
// import content from '@/content/projects/0728-nnd-byelections-july28'
// import content from '@/content/projects/demo/demo-cinemaguide-main'
// import content from '@/content/projects/demo/demo-score-cards-demo'
// import content from '@/content/projects/demo/demo-leaflet'
// import content from '@/content/projects/top-10-robots'
// import content from '@/content/projects/demo/simple-charts'

// ! Templates
// import content from '@/content/projects/template/template-news-map'

// ! Editors
// import content from '@/content/editors/news-map'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js